import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const LookupRedirectAction: ComponentType<RouteContext> & LoadableExport.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "LookupRedirectAction" */ './LookupRedirectAction'),
		loading: () => null,
	});
